/**
 * Animation constants used throughout the application
 */

export const COUNTER_DURATION = 3.2

export const SPRING_TRANSITION = {
  type: 'spring',
  stiffness: 150,
  damping: 19,
  mass: 1.2,
}
